import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_filiation",
  ref: "createAccountModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y m-5" }
const _hoisted_9 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Datos generales</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Datos de ingreso del caso</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Enfermedades</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\">Familiares</h3></div></div>", 1)
const _hoisted_11 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tipo de documento:", -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "CEDULA DE IDENTIDAD" }, " Cédula de identidad ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "PASAPORTE" }, "Pasaporte", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "CARNET DE EXTRANJERO" }, " Carnet de extranjero ", -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Número de documento:", -1)
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Complemento:", -1)
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "col-md-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "col-md-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"width":"7rem","height":"7rem"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_41 = { class: "col-md-12 text-center" }
const _hoisted_42 = ["src"]
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  required: ""
}, "Nombres:", -1)
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Primer Apellido:", -1)
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Segundo Apellido:", -1)
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Fecha de nacimiento:", -1)
const _hoisted_58 = { class: "col-md-4" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Edad:", -1)
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Género:", -1)
const _hoisted_63 = ["disabled"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", { value: "MASCULINO" }, "Masculino", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("option", { value: "FEMENINO" }, "Femenino", -1)
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "País:", -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Departamento:", -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Provincia:", -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Localidad:", -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Domicilio:", -1)
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Número Telefono:", -1)
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Grado de Instrucción:", -1)
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<option value=\"PRIMARIA\">Primaria</option><option value=\"SECUNDARIA\">Secundaria</option><option value=\"TÉCNICO\">Técnico</option><option value=\"UNIVERSITARIO\">Universitario</option><option value=\"POSTGRADO\">Postgrado</option>", 5)
const _hoisted_95 = [
  _hoisted_90
]
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Oficio/Profesión:", -1)
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-md-6" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Idioma Primario:", -1)
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Idioma Secundario:", -1)
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-md-6" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Religión:", -1)
const _hoisted_109 = /*#__PURE__*/_createStaticVNode("<option value=\"CATOLICO\">Católico</option><option value=\"CRISTIANO\">Cristiano</option><option value=\"JUDIO\">Judio</option><option value=\"ISLAM\">Islam</option><option value=\"OTRO\">Otro</option>", 5)
const _hoisted_114 = [
  _hoisted_109
]
const _hoisted_115 = { class: "col-md-6" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Identificación étnica:", -1)
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Estado civil:", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("option", { value: "SOLTERO" }, "Soltero(a)", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("option", { value: "CASADO" }, "Casado(a)", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("option", { value: "DIVORCIADO" }, "Divorciado(a)", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("option", { value: "VIUDO" }, "Viudo(a)", -1)
const _hoisted_125 = [
  _hoisted_121,
  _hoisted_122,
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = { class: "col-md-6" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Identidad Sexual:", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("option", { value: "HETEROSEXUAL" }, "Heterosexual", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "HOMOSEXUAL" }, "Homosexual", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("option", { value: "LESBIANA" }, "Lesbiana", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("option", { value: "OTRO" }, "Otro", -1)
const _hoisted_132 = [
  _hoisted_128,
  _hoisted_129,
  _hoisted_130,
  _hoisted_131
]
const _hoisted_133 = { "data-kt-stepper-element": "content" }
const _hoisted_134 = { class: "w-100" }
const _hoisted_135 = { class: "row" }
const _hoisted_136 = { class: "col-md-6" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Centro Penitenciario:", -1)
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_139 = { class: "col-md-6" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Fecha de Ingreso:", -1)
const _hoisted_141 = { class: "row" }
const _hoisted_142 = { class: "col-md-6" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Número de file:", -1)
const _hoisted_144 = { class: "col-md-6" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Jurisdicción:", -1)
const _hoisted_146 = /*#__PURE__*/_createStaticVNode("<option value=\"LA PAZ\">LA PAZ</option><option value=\"CHUQUISACA\">CHUQUISACA</option><option value=\"SANTA CRUZ\">SANTA CRUZ</option><option value=\"COCHABAMBA\">COCHABAMBA</option><option value=\"TARIJA\">TARIJA</option><option value=\"BENI\">BENI</option><option value=\"POTOSI\">POTOSI</option><option value=\"ORURO\">ORURO</option><option value=\"PANDO\">PANDO</option>", 9)
const _hoisted_155 = [
  _hoisted_146
]
const _hoisted_156 = { class: "row" }
const _hoisted_157 = { class: "col-md-6" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Juez que lleva la causa:", -1)
const _hoisted_159 = { class: "col-md-6" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Juzgado que lleva la causa:", -1)
const _hoisted_161 = { class: "row" }
const _hoisted_162 = { class: "col-md-6" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Descripción código:", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("option", { value: "CÓDIGO ÚNICO" }, "CÓDIGO ÚNICO", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", { value: "IANUS" }, "IANUS", -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("option", { value: "NUREJ" }, "NUREJ", -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("option", { value: "SIN CÓDIGO" }, "SIN CÓDIGO", -1)
const _hoisted_168 = [
  _hoisted_164,
  _hoisted_165,
  _hoisted_166,
  _hoisted_167
]
const _hoisted_169 = { class: "col-md-6" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Código:", -1)
const _hoisted_171 = ["disabled"]
const _hoisted_172 = { class: "row" }
const _hoisted_173 = { class: "col-md-6" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Situación jurídica:", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("option", { value: "SENTENCIADO" }, "Sentenciado", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("option", { value: "PREVENTIVO" }, "Preventivo", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("option", { value: "APREMIO" }, "Apremio", -1)
const _hoisted_178 = [
  _hoisted_175,
  _hoisted_176,
  _hoisted_177
]
const _hoisted_179 = { class: "col-md-6" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tipo de delíto:", -1)
const _hoisted_181 = /*#__PURE__*/_createTextVNode(" No existen coincidencias con su búsqueda. ")
const _hoisted_182 = { class: "row" }
const _hoisted_183 = { class: "col-md-6" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Años de sentencia:", -1)
const _hoisted_185 = ["disabled"]
const _hoisted_186 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">0</option><option value=\"1\">1</option><option value=\"2\">2</option><option value=\"3\">3</option><option value=\"4\">4</option><option value=\"5\">5</option><option value=\"6\">6</option><option value=\"7\">7</option><option value=\"8\">8</option><option value=\"9\">9</option><option value=\"10\">10</option><option value=\"11\">11</option><option value=\"12\">12</option><option value=\"13\">13</option><option value=\"14\">14</option><option value=\"15\">15</option><option value=\"16\">16</option><option value=\"17\">17</option><option value=\"18\">18</option><option value=\"19\">19</option><option value=\"20\">20</option><option value=\"21\">21</option><option value=\"22\">22</option><option value=\"23\">23</option><option value=\"24\">24</option><option value=\"25\">25</option><option value=\"26\">26</option><option value=\"27\">27</option><option value=\"28\">28</option><option value=\"29\">29</option><option value=\"30\">30</option>", 31)
const _hoisted_217 = [
  _hoisted_186
]
const _hoisted_218 = { class: "col-md-6" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Meses de sentencia:", -1)
const _hoisted_220 = ["disabled"]
const _hoisted_221 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">0</option><option value=\"1\">1</option><option value=\"2\">2</option><option value=\"3\">3</option><option value=\"4\">4</option><option value=\"5\">5</option><option value=\"6\">6</option><option value=\"7\">7</option><option value=\"8\">8</option><option value=\"9\">9</option><option value=\"10\">10</option><option value=\"11\">11</option>", 12)
const _hoisted_233 = [
  _hoisted_221
]
const _hoisted_234 = { class: "col-md-12" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Observaciones:", -1)
const _hoisted_236 = { "data-kt-stepper-element": "content" }
const _hoisted_237 = { class: "w-100" }
const _hoisted_238 = { class: "row" }
const _hoisted_239 = { class: "col-md-6" }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Enfermedad:", -1)
const _hoisted_241 = { class: "col-md-6" }
const _hoisted_242 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Otra Enfermedad:", -1)
const _hoisted_243 = ["disabled"]
const _hoisted_244 = { class: "row" }
const _hoisted_245 = { class: "col-md-12" }
const _hoisted_246 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "¿Necesita medicación?:", -1)
const _hoisted_247 = { class: "form-check" }
const _hoisted_248 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_249 = { class: "row" }
const _hoisted_250 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_251 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Medicación:", -1)
const _hoisted_252 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_253 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Otra Medicación:", -1)
const _hoisted_254 = ["disabled"]
const _hoisted_255 = { class: "row" }
const _hoisted_256 = { class: "col-md-12" }
const _hoisted_257 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Observación:", -1)
const _hoisted_258 = { "data-kt-stepper-element": "content" }
const _hoisted_259 = { class: "w-100" }
const _hoisted_260 = { class: "row" }
const _hoisted_261 = { class: "col-md-5" }
const _hoisted_262 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nombre Completo:", -1)
const _hoisted_263 = { class: "col-md-3" }
const _hoisted_264 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Parentesco:", -1)
const _hoisted_265 = /*#__PURE__*/_createStaticVNode("<option value=\"PADRE\">Padre</option><option value=\"MADRE\">Madre</option><option value=\"HERMANO(A)\">Hermano(a)</option><option value=\"ESPOSO(A)\">Esposo(a)</option><option value=\"HIJO(A)\">Hijo(a)</option><option value=\"ABUELO(A)\">Abuelo(a)</option><option value=\"SOBRINO(A)\">Sobrino(a)</option><option value=\"PRIMO(A)\">Primo(a)</option><option value=\"NIETO(A)\">Nieto(a)</option><option value=\"SUEGRO(A)\">Suegro(a)</option>", 10)
const _hoisted_275 = [
  _hoisted_265
]
const _hoisted_276 = { class: "col-md-4" }
const _hoisted_277 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Teléfono Familiar:", -1)
const _hoisted_278 = { class: "row" }
const _hoisted_279 = { class: "col-md-5" }
const _hoisted_280 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nombre Completo:", -1)
const _hoisted_281 = ["disabled"]
const _hoisted_282 = { class: "col-md-3" }
const _hoisted_283 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Parentesco:", -1)
const _hoisted_284 = ["disabled"]
const _hoisted_285 = /*#__PURE__*/_createStaticVNode("<option value=\"PADRE\">Padre</option><option value=\"MADRE\">Madre</option><option value=\"HERMANO(A)\">Hermano(a)</option><option value=\"ESPOSO(A)\">Esposo(a)</option><option value=\"HIJO(A)\">Hijo(a)</option><option value=\"ABUELO(A)\">Abuelo(a)</option><option value=\"SOBRINO(A)\">Sobrino(a)</option><option value=\"PRIMO(A)\">Primo(a)</option><option value=\"NIETO(A)\">Nieto(a)</option><option value=\"SUEGRO(A)\">Suegro(a)</option>", 10)
const _hoisted_295 = [
  _hoisted_285
]
const _hoisted_296 = { class: "col-md-4" }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Teléfono Familiar:", -1)
const _hoisted_298 = ["disabled"]
const _hoisted_299 = { class: "d-flex flex-stack pt-15" }
const _hoisted_300 = { class: "me-2" }
const _hoisted_301 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_302 = /*#__PURE__*/_createTextVNode(" Atrás ")
const _hoisted_303 = { class: "indicator-label" }
const _hoisted_304 = /*#__PURE__*/_createTextVNode(" Enviar ")
const _hoisted_305 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_306 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Por favor espera "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_307 = { class: "indicator-label" }
const _hoisted_308 = /*#__PURE__*/_createTextVNode(" Editar ")
const _hoisted_309 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_310 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Por favor espera "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_311 = {
  key: 2,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_312 = /*#__PURE__*/_createTextVNode(" Siguiente ")
const _hoisted_313 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.dataToEdit.state == 'editing')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, " Edición datos persona privada de libertad "))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, "Filiación nueva persona privada de libertad")),
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearData && _ctx.clearData(...args)))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              onSubmit: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.tipo_documento) = $event)),
                        disabled: _ctx.haveData
                      }, _hoisted_20, 8, _hoisted_16), [
                        [_vModelSelect, _ctx.formData.tipo_documento]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        id: "numero_doc",
                        min: "1",
                        pattern: "^[0-9]+",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.numero_doc) = $event)),
                        disabled: !_ctx.formData.tipo_documento || _ctx.haveData
                      }, null, 8, _hoisted_23), [
                        [_vModelText, _ctx.formData.numero_doc]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "complemento",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.complemento) = $event)),
                        disabled: !_ctx.formData.numero_doc || _ctx.haveData
                      }, null, 8, _hoisted_26), [
                        [_vModelText, _ctx.formData.complemento]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      (_ctx.dataToEdit.state != 'editing')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-success px-3",
                            disabled: 
                          _ctx.formData.tipo_documento != 'CEDULA DE IDENTIDAD' ||
                          !_ctx.formData.numero_doc ||
                          _ctx.haveData
                        ,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchSigep()))
                          }, _hoisted_31, 8, _hoisted_29))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      (_ctx.dataToEdit.state != 'editing')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-warning px-3",
                            disabled: !_ctx.haveData,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetformData()))
                          }, _hoisted_36, 8, _hoisted_34))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                      : _createCommentVNode("", true),
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      (!_ctx.formData.fotografia)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.personImg,
                            class: "img-fluid img-thumbnail",
                            width: "150",
                            height: "150",
                            alt: "without_image"
                          }, null, 8, _hoisted_42))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.formData.fotografia,
                            class: "img-fluid img-thumbnail",
                            width: "150",
                            height: "150",
                            alt: "SegipImage"
                          }, null, 8, _hoisted_43))
                    ]),
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "nombres",
                          style: {"text-transform":"uppercase"},
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.nombres) = $event)),
                          disabled: _ctx.haveData
                        }, null, 8, _hoisted_48), [
                          [_vModelText, _ctx.formData.nombres]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "p_apellido",
                          style: {"text-transform":"uppercase"},
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.primerApellido) = $event)),
                          disabled: _ctx.haveData
                        }, null, 8, _hoisted_51), [
                          [_vModelText, _ctx.formData.primerApellido]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "s_apellido",
                          style: {"text-transform":"uppercase"},
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.segundoApellido) = $event)),
                          disabled: _ctx.haveData
                        }, null, 8, _hoisted_54), [
                          [_vModelText, _ctx.formData.segundoApellido]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createVNode(_component_Datepicker, {
                          uid: "f_nac",
                          modelValue: _ctx.formData.fechaNacimiento,
                          "onUpdate:modelValue": [
                            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.fechaNacimiento) = $event)),
                            _cache[10] || (_cache[10] = ($event: any) => (_ctx.age(_ctx.formData.fechaNacimiento)))
                          ],
                          type: "date",
                          locale: "es",
                          cancelText: "Cancelar",
                          selectText: "Seleccionar",
                          monthNameFormat: "long",
                          enableTimePicker: false,
                          format: _ctx.format,
                          required: "",
                          disabled: _ctx.haveData
                        }, null, 8, ["modelValue", "format", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "edad",
                          style: {"text-transform":"uppercase"},
                          value: _ctx.actualAge,
                          readonly: ""
                        }, null, 8, _hoisted_60)
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "aria-label": "select",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.genero) = $event)),
                          disabled: _ctx.haveData
                        }, _hoisted_66, 8, _hoisted_63), [
                          [_vModelSelect, _ctx.formData.genero]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createVNode(_component_v_select, {
                          label: "name",
                          modelValue: _ctx.formData.lugarNacimientoPais,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.lugarNacimientoPais) = $event)),
                          options: _ctx.countries[0].result,
                          reduce: (name) => name.name,
                          disabled: _ctx.haveData
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_70
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createVNode(_component_v_select, {
                          label: "departamento",
                          modelValue: _ctx.formData.lugarNacimientoDepartamento,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.lugarNacimientoDepartamento) = $event)),
                          options: _ctx.departamentsList,
                          reduce: (departamento) => departamento.departamento,
                          "onOption:selected": _cache[14] || (_cache[14] = ($event: any) => (
                            _ctx.nameProvince(_ctx.formData.lugarNacimientoDepartamento)
                          )),
                          disabled: _ctx.haveData
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_73
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce", "disabled"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _createVNode(_component_v_select, {
                          label: "provincia",
                          modelValue: _ctx.formData.lugarNacimientoProvincia,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.lugarNacimientoProvincia) = $event)),
                          options: _ctx.provincesList,
                          reduce: (provincia) => provincia.provincia,
                          "onOption:selected": _cache[16] || (_cache[16] = ($event: any) => (
                            _ctx.nameMunicipality(_ctx.formData.lugarNacimientoProvincia)
                          )),
                          disabled: _ctx.haveData
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_77
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _hoisted_79,
                        _createVNode(_component_v_select, {
                          label: "municipio",
                          modelValue: _ctx.formData.lugarNacimientoLocalidad,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.lugarNacimientoLocalidad) = $event)),
                          options: _ctx.municipalitiesList,
                          reduce: (municipio) => municipio.municipio,
                          disabled: _ctx.haveData
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_80
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce", "disabled"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "direccion",
                          style: {"text-transform":"uppercase"},
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.domicilio) = $event)),
                          disabled: _ctx.haveData
                        }, null, 8, _hoisted_84), [
                          [_vModelText, _ctx.formData.domicilio]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          id: "telefono",
                          min: "1",
                          pattern: "^[0-9]+",
                          style: {"text-transform":"uppercase"},
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.telefono) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.formData.telefono]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "aria-label": "select",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.grado_instruccion) = $event))
                        }, _hoisted_95, 512), [
                          [_vModelSelect, _ctx.formData.grado_instruccion]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _hoisted_97,
                        _createVNode(_component_v_select, {
                          taggable: "",
                          label: "nombre_profesion",
                          modelValue: _ctx.formData.oficio_profesion,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.oficio_profesion) = $event)),
                          options: _ctx.jobs,
                          reduce: 
                            (nombre_profesion) =>
                              nombre_profesion.nombre_profesion
                          
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_98
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createVNode(_component_v_select, {
                          label: "Nombre",
                          modelValue: _ctx.formData.idioma,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.idioma) = $event)),
                          options: _ctx.languages,
                          reduce: (Nombre) => Nombre.Nombre
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_102
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce"])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _hoisted_104,
                        _createVNode(_component_v_select, {
                          label: "Nombre",
                          modelValue: _ctx.formData.idioma1,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.idioma1) = $event)),
                          options: _ctx.languages,
                          reduce: (Nombre) => Nombre.Nombre
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_105
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _hoisted_108,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "aria-label": "select",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.religion) = $event))
                        }, _hoisted_114, 512), [
                          [_vModelSelect, _ctx.formData.religion]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _hoisted_116,
                        _createVNode(_component_v_select, {
                          label: "identidad_originaria",
                          modelValue: _ctx.formData.id_etnica,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.id_etnica) = $event)),
                          options: _ctx.original_identity,
                          reduce: 
                            (identidad_originaria) =>
                              identidad_originaria.identidad_originaria
                          
                        }, {
                          "no-options": _withCtx(({ search, searching, loading }) => [
                            _hoisted_117
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _hoisted_120,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "aria-label": "select",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.estado_civil) = $event))
                        }, _hoisted_125, 512), [
                          [_vModelSelect, _ctx.formData.estado_civil]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _hoisted_127,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "aria-label": "select",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.id_sexual) = $event))
                        }, _hoisted_132, 512), [
                          [_vModelSelect, _ctx.formData.id_sexual]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _createVNode(_component_v_select, {
                        label: "nombre",
                        modelValue: _ctx.formData.centro_penitenciario,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.centro_penitenciario) = $event)),
                        options: _ctx.centersList,
                        reduce: (nombre) => nombre.id_centro
                      }, {
                        "no-options": _withCtx(({ search, searching, loading }) => [
                          _hoisted_138
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "reduce"])
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _hoisted_140,
                      _createVNode(_component_Datepicker, {
                        uid: "f_ingreso",
                        modelValue: _ctx.formData.fechaIngreso,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.fechaIngreso) = $event)),
                        type: "date",
                        locale: "es",
                        cancelText: "Cancelar",
                        selectText: "Seleccionar",
                        monthNameFormat: "long",
                        enableTimePicker: false,
                        format: _ctx.format,
                        required: ""
                      }, null, 8, ["modelValue", "format"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _hoisted_143,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "file",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.numeroFile) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.numeroFile]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_144, [
                      _hoisted_145,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.jurisdiccion) = $event))
                      }, _hoisted_155, 512), [
                        [_vModelSelect, _ctx.formData.jurisdiccion]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("div", _hoisted_157, [
                      _hoisted_158,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "juez",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.juez) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.juez]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_159, [
                      _hoisted_160,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "juzgado",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.juzgado) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.juzgado]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, [
                      _hoisted_163,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.descripcion_codigo) = $event))
                      }, _hoisted_168, 512), [
                        [_vModelSelect, _ctx.formData.descripcion_codigo]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_169, [
                      _hoisted_170,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "cod_unico",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.codigo) = $event)),
                        disabled: _ctx.formData.descripcion_codigo == 'SIN CÓDIGO'
                      }, null, 8, _hoisted_171), [
                        [_vModelText, _ctx.formData.codigo]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_172, [
                    _createElementVNode("div", _hoisted_173, [
                      _hoisted_174,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.situacion_juridica) = $event))
                      }, _hoisted_178, 512), [
                        [_vModelSelect, _ctx.formData.situacion_juridica]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_179, [
                      _hoisted_180,
                      _createVNode(_component_v_select, {
                        multiple: "",
                        label: "descripcion_delito",
                        modelValue: _ctx.formData.delito,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.delito) = $event)),
                        options: _ctx.crimesList,
                        reduce: 
                          (descripcion_delito) => descripcion_delito.id_delito
                        
                      }, {
                        "no-options": _withCtx(({ search, searching, loading }) => [
                          _hoisted_181
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "reduce"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_182, [
                    _createElementVNode("div", _hoisted_183, [
                      _hoisted_184,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.anios_sentencia) = $event)),
                        disabled: 
                          _ctx.formData.situacion_juridica == 'PREVENTIVO' ||
                          _ctx.formData.situacion_juridica == 'APREMIO'
                        
                      }, _hoisted_217, 8, _hoisted_185), [
                        [_vModelSelect, _ctx.formData.anios_sentencia]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_218, [
                      _hoisted_219,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.meses_sentencia) = $event)),
                        disabled: 
                          _ctx.formData.situacion_juridica == 'PREVENTIVO' ||
                          _ctx.formData.situacion_juridica == 'APREMIO' ||
                          !_ctx.formData.anios_sentencia
                        
                      }, _hoisted_233, 8, _hoisted_220), [
                        [_vModelSelect, _ctx.formData.meses_sentencia]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_234, [
                      _hoisted_235,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "text",
                        class: "form-control",
                        id: "nurej",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData.observaciones) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.observaciones]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_236, [
                _createElementVNode("div", _hoisted_237, [
                  _createElementVNode("div", _hoisted_238, [
                    _createElementVNode("div", _hoisted_239, [
                      _hoisted_240,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "enfermedad",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.enfermedad) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.enfermedad]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_241, [
                      _hoisted_242,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "enfermedad1",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.formData.enfermedad1) = $event)),
                        disabled: !_ctx.formData.enfermedad
                      }, null, 8, _hoisted_243), [
                        [_vModelText, _ctx.formData.enfermedad1]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_244, [
                    _createElementVNode("div", _hoisted_245, [
                      _hoisted_246,
                      _createElementVNode("div", _hoisted_247, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.medicacion) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.formData.medicacion]
                        ]),
                        _createElementVNode("label", _hoisted_248, _toDisplayString(_ctx.formData.medicacion ? "Si" : "No"), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_249, [
                    (_ctx.formData.medicacion)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                          _hoisted_251,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "desc_medicacion",
                            style: {"text-transform":"uppercase"},
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formData.descripcionMedicacion) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formData.descripcionMedicacion]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.medicacion)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                          _hoisted_253,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "desc_medicacion1",
                            style: {"text-transform":"uppercase"},
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formData.descripcionMedicacion1) = $event)),
                            disabled: !_ctx.formData.enfermedad1
                          }, null, 8, _hoisted_254), [
                            [_vModelText, _ctx.formData.descripcionMedicacion1]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_255, [
                    _createElementVNode("div", _hoisted_256, [
                      _hoisted_257,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "text",
                        class: "form-control",
                        id: "obsEnfermedades",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formData.obsEnfermedades) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.obsEnfermedades]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_258, [
                _createElementVNode("div", _hoisted_259, [
                  _createElementVNode("div", _hoisted_260, [
                    _createElementVNode("div", _hoisted_261, [
                      _hoisted_262,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "nombreFamiliar",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.formData.nombreFamiliar) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.nombreFamiliar]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_263, [
                      _hoisted_264,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formData.parentesco) = $event))
                      }, _hoisted_275, 512), [
                        [_vModelSelect, _ctx.formData.parentesco]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_276, [
                      _hoisted_277,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        id: "telefono_familiar",
                        min: "1",
                        pattern: "^[0-9]+",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formData.telefonoFamiliar) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.telefonoFamiliar]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_278, [
                    _createElementVNode("div", _hoisted_279, [
                      _hoisted_280,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "nombreFamiliar",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formData.nombreFamiliar1) = $event)),
                        disabled: !_ctx.formData.nombreFamiliar
                      }, null, 8, _hoisted_281), [
                        [_vModelText, _ctx.formData.nombreFamiliar1]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_282, [
                      _hoisted_283,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "select",
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.formData.parentesco1) = $event)),
                        disabled: !_ctx.formData.nombreFamiliar1
                      }, _hoisted_295, 8, _hoisted_284), [
                        [_vModelSelect, _ctx.formData.parentesco1]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_296, [
                      _hoisted_297,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        id: "telefono_familiar",
                        min: "1",
                        pattern: "^[0-9]+",
                        style: {"text-transform":"uppercase"},
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formData.telefonoFamiliar1) = $event)),
                        disabled: !_ctx.formData.nombreFamiliar1
                      }, null, 8, _hoisted_298), [
                        [_vModelText, _ctx.formData.telefonoFamiliar1]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_299, [
                _createElementVNode("div", _hoisted_300, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createElementVNode("span", _hoisted_301, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                    ]),
                    _hoisted_302
                  ])
                ]),
                _createElementVNode("div", null, [
                  (
                      _ctx.currentStepIndex === _ctx.totalSteps - 1 &&
                      _ctx.dataToEdit.state != 'editing'
                    )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        class: "btn btn-lg btn-primary",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.formSubmit()))
                      }, [
                        _createElementVNode("span", _hoisted_303, [
                          _hoisted_304,
                          _createElementVNode("span", _hoisted_305, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        _hoisted_306
                      ]))
                    : (
                      _ctx.currentStepIndex === _ctx.totalSteps - 1 &&
                      _ctx.dataToEdit.state == 'editing'
                    )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "submit",
                          class: "btn btn-lg btn-primary",
                          onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.editForm()))
                        }, [
                          _createElementVNode("span", _hoisted_307, [
                            _hoisted_308,
                            _createElementVNode("span", _hoisted_309, [
                              _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                            ])
                          ]),
                          _hoisted_310
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_311, [
                          _hoisted_312,
                          _createElementVNode("span", _hoisted_313, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                ])
              ])
            ], 32)
          ], 512)
        ])
      ])
    ])
  ], 512))
}